export default __webpack_public_path__ + "static/media/Army.a3a0a35f.svg";